import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function PrivacyPage() {
  return <div className="min-h-screen bg-gray-900 text-white font-sans" data-id="element-3221">
      {/* Header */}
      <header className="bg-black border-b border-gray-800 py-4 px-4" data-id="element-3222">
        <div className="max-w-4xl mx-auto flex items-center gap-4" data-id="element-3223">
          <Link to="/meta-martes" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-3224">
            <ArrowLeft className="w-5 h-5" data-id="element-3225" />
            <span className="text-sm" data-id="element-3226">Volver</span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-3227">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-3228">
          Política de Privacidad
        </h1>

        <div className="text-gray-300 text-sm md:text-base space-y-6 leading-relaxed" data-id="element-3229">
          <p data-id="element-3230">
            En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
            privacidad. Esta política describe cómo recopilamos, usamos y
            protegemos tu información personal.
          </p>

          <section data-id="element-3231">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3232">
              1. Información que Recopilamos
            </h2>
            <p className="mb-4" data-id="element-3233">
              Recopilamos información que nos proporcionas directamente,
              incluyendo:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3234">
              <li data-id="element-3235">Nombre y dirección de correo electrónico</li>
              <li data-id="element-3236">Número de teléfono móvil</li>
              <li data-id="element-3237">Información de registro del evento</li>
              <li data-id="element-3238">Comunicaciones que mantienes con nosotros</li>
            </ul>
          </section>

          <section data-id="element-3239">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3240">
              2. Uso de la Información
            </h2>
            <p className="mb-4" data-id="element-3241">Utilizamos tu información para:</p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3242">
              <li data-id="element-3243">
                Proporcionar acceso al masterclass y materiales relacionados
              </li>
              <li data-id="element-3244">Enviar comunicaciones sobre el evento</li>
              <li data-id="element-3245">
                Enviar mensajes SMS/texto con actualizaciones y recordatorios
              </li>
              <li data-id="element-3246">Mejorar nuestros servicios y contenido</li>
              <li data-id="element-3247">Cumplir con obligaciones legales</li>
            </ul>
          </section>

          <section data-id="element-3248">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3249">
              3. Compartir Información
            </h2>
            <p className="mb-4" data-id="element-3250">
              No se compartirá información móvil con terceros ni afiliados con
              fines de marketing ni promocionales. Los datos de suscripción y el
              consentimiento para el uso de mensajes de texto no se compartirán
              con terceros.
            </p>
            <p data-id="element-3251">
              No vendemos ni compartimos tu información personal con terceros
              para fines de marketing. Podemos compartir información con
              proveedores de servicios que nos ayudan a operar nuestro negocio.
            </p>
          </section>

          <section data-id="element-3252">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3253">
              4. Mensajes SMS/Texto
            </h2>
            <p className="mb-4" data-id="element-3254">
              Al proporcionar tu número de teléfono móvil y dar tu
              consentimiento, aceptas recibir mensajes SMS/texto recurrentes de
              True Marketer LLC, incluyendo:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3255">
              <li data-id="element-3256">Actualizaciones del programa</li>
              <li data-id="element-3257">Información de capacitación</li>
              <li data-id="element-3258">Mensajes de marketing/promocionales</li>
              <li data-id="element-3259">Recordatorios de eventos</li>
            </ul>
            <p className="mt-4" data-id="element-3260">
              La frecuencia de los mensajes varía. Pueden aplicar tarifas de
              mensajes y datos según tu plan de telefonía móvil.
            </p>
            <p className="mt-4" data-id="element-3261">
              <strong className="text-white" data-id="element-3262">Para cancelar:</strong> Responde
              STOP a cualquier mensaje para dejar de recibir mensajes SMS.
            </p>
            <p className="mt-2" data-id="element-3263">
              <strong className="text-white" data-id="element-3264">Para ayuda:</strong> Responde HELP
              para obtener asistencia.
            </p>
            <p className="mt-4" data-id="element-3265">
              El consentimiento para recibir mensajes SMS no es una condición de
              compra.
            </p>
          </section>

          <section data-id="element-3266">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3267">
              5. Seguridad de Datos
            </h2>
            <p data-id="element-3268">
              Implementamos medidas de seguridad técnicas y organizativas
              apropiadas para proteger tu información personal contra acceso no
              autorizado, alteración o destrucción.
            </p>
          </section>

          <section data-id="element-3269">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3270">
              6. Tus Derechos
            </h2>
            <p data-id="element-3271">
              Tienes derecho a acceder, corregir o eliminar tu información
              personal. Para ejercer estos derechos, contáctanos en:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] underline" data-id="element-3272">
                support@truemarketer.com
              </a>
            </p>
          </section>

          <section data-id="element-3273">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3274">
              7. Cookies
            </h2>
            <p data-id="element-3275">
              Utilizamos cookies y tecnologías similares para mejorar tu
              experiencia en nuestro sitio web y analizar el uso del sitio.
            </p>
          </section>

          <section data-id="element-3276">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-3277">Contacto</h2>
            <p data-id="element-3278">
              Para preguntas sobre esta política de privacidad, contacta:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] underline" data-id="element-3279">
                support@truemarketer.com
              </a>
            </p>
          </section>

          <section className="mt-12 pt-8 border-t border-gray-700" data-id="element-3280">
            <p className="text-gray-500 text-sm" data-id="element-3281">
              Última actualización: Febrero 2025
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-6 px-4" data-id="element-3282">
        <div className="max-w-4xl mx-auto text-center" data-id="element-3283">
          <p className="text-gray-600 text-xs mb-2" data-id="element-3284">
            &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-xs" data-id="element-3285">
            Soporte:{' '}
            <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] transition-colors" data-id="element-3286">
              support@truemarketer.com
            </a>
          </p>
          <div className="flex items-center justify-center gap-4 text-xs mt-2" data-id="element-3287">
            <Link to="/terms" className="text-gray-500 hover:text-white transition-colors underline" data-id="element-3288">
              Términos
            </Link>
            <span className="text-gray-600" data-id="element-3289">|</span>
            <span className="text-white" data-id="element-3290">Privacidad</span>
          </div>
        </div>
      </footer>
    </div>;
}